import React,{useEffect, useRef} from 'react';


import NavbarStyles from './Navbar.module.css';
import NavBrand from './NavBrand/NavBrand.js';
import NavElements from './NavElements/NavElements.js';
import NavElement from './NavElements/NavElement/NavElement.js';
import {Home} from '../Home/Home.module.css';
import {Skills} from '../Skills/Skills.module.css';
import {Hobbies} from '../Hobbies/Hobbies.module.css';


const DARK_BG_CLASSES=['navbar-dark','bg-dark',NavbarStyles['Box-Shadow']];


function toggleNavBarBackground(navBarRef,event){
    const scrolledFromTop=document.documentElement.scrollTop!==0;
    const navBarRefClasses=navBarRef.classList;
    if (!scrolledFromTop){ //Remove black background
        DARK_BG_CLASSES.forEach(darkBackgroundClass=>navBarRefClasses.remove(darkBackgroundClass));
        return;
    }
    //Add black background
    for (let darkBackgroundClass of DARK_BG_CLASSES){
        if (!navBarRefClasses.contains(darkBackgroundClass))
            navBarRefClasses.add(darkBackgroundClass);
    }
}
export default function Navbar(){
    const imagePathPrefix=
        process.env.NODE_ENV
            ==='production'
                ?'http://jprustom.github.io/personal-website'
                :'';
    const navBarRef=useRef(null);
    useEffect(()=>{
        window.addEventListener('scroll',toggleNavBarBackground.bind(null,navBarRef.current));
    });
    return <nav ref={navBarRef} id={NavbarStyles.Navbar} className="fixed-top navbar navbar-expand-lg ">
            <NavBrand imagePath={imagePathPrefix+'/favicon.png'} link={`#${Home}`}/>
            <NavElements>
                <NavElement name='Skills' link={`#${Skills}`}/>
                <NavElement name='Hobbies' link={`#${Hobbies}`}/>
                <NavElement name='Projects' disabled/>
                <NavElement name='Blog' disabled/>
            </NavElements>      
            </nav>
}